/**
 * 供应商模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const vendorMgr = {
    //得到指定临时token人员的基本信息
    list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/vendor-mgr/s-grid`, { params: params});
    }
}

export default vendorMgr;



// WEBPACK FOOTER //
// ./src/api/vendorMgr.js